import {Component, ViewEncapsulation} from '@angular/core';
import { FieldGroupTypeConfig, FieldType, FieldWrapper } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { AppService } from '../app.service';

  @Component({
    selector: 'custom-accordian',
    styles: [`
        .accordian-card{
            margin:0;
            margin-bottom:10px;
        }
        .title-blk {
             color: "#006884";
             font-size: 16px;
             width: 100%;
             margin: 0; 
        }
        .iconfloatright { 
            float: right;
            text-align: right;
        }
        .my_inner_selected_cvpc_type{
            padding-left:5px;
        }
        .check-box{
            height: 18px;
            width: 18px;
            text-align: center;
            border-radius: 4px;
            background: #007382;
            margin-left: 26px;
        }
        .relates_to{
            color:#000000;
            font-size:14px;
            font-weight: 600;
        }
        .check-tick{
            height: 16px;
            width: 16px;
            color: white;
            font-weight: 600;
        }
        .card-radius{
            border-radius: 4px;
            box-shadow: 0px 0px 6px #00000029;
            margin: 16px 0 0 0;
        }
        .card-radius_vpc_add{
            border-radius: 4px;
            box-shadow: 0px 0px 6px #00000029;
            margin: -10px 0 0 0;
        }
       
        `
    ],
    template: `
    <ion-row *ngIf="form_name=='VPC_ADD'">
            <ion-col size="10">
                    <h3 class="relates_to">{{ to.label }}</h3> 
            </ion-col>
    </ion-row>
    <ion-card  [ngClass]="{'card-radius':form_name!='VPC_ADD', 
    'card-radius_vpc_add':form_name=='VPC_ADD'}">
        <div *ngIf="form_name=='QUESTIONAIRE'" style="background:#EDF5F5;padding: 5px;">
        <ion-row>
            <ion-col class="ion-align-self-center">
                <h3 style="color:#007382;font-size:12px;" class="title-blk">{{ to.label }}</h3>
            </ion-col>
            <ion-col id="{{to.label}}" size="3" class="ion-align-self-center iconfloatright">
                
                <div class="check-box"  *ngIf="to.expanded">
                    <ion-icon class="check-tick"  name="checkmark-outline" (click)="expandItem()"></ion-icon>
                </div>
                <div style="margin-left:26px;background:white;border-radius:4px;height:18px;width:18px;border:0.1em solid #007382;" *ngIf="!to.questionAttempted && !to.expanded" (click)="expandItem()">

                </div>
            </ion-col>
        </ion-row>
        </div>
        
        <ion-card-header *ngIf="form_name!='QUESTIONAIRE' && form_name!='VPC_ADD'">
        <ion-row>
            <ion-col size="10">
                    <h3 class="title-blk">{{ to.label }}</h3> 
                </ion-col>
            <ion-col size="2" class="iconfloatright" >
                <ion-icon  size="large" name="chevron-down-outline" *ngIf="!to.questionAttempted && !to.expanded" (click)="expandItem()" ></ion-icon>
                <ion-icon size="large" name="chevron-up-outline" *ngIf="to.expanded" (click)="expandItem()" ></ion-icon>
            </ion-col>
        </ion-row>
        </ion-card-header>
        
        <div *ngIf="form_name=='QUESTIONAIRE'">
                <app-accordian expandHeight="100px" [expanded]="to.expanded" *ngIf="to.expanded" > 
                    <ng-container #fieldComponent></ng-container>
                </app-accordian>
        </div>
        <div style="padding:10px;" *ngIf="form_name=='VPC_ADD'">
            <app-accordian expandHeight="100px" [expanded]="to.expanded" *ngIf="!to.questionAttempted || to.expanded" > 
                <ng-container #fieldComponent></ng-container>
            </app-accordian>
        </div>
        <div *ngIf="form_name!='QUESTIONAIRE' && form_name!='VPC_ADD'">
            <app-accordian expandHeight="100px" [expanded]="!to.questionAttempted && to.expanded" *ngIf="!to.questionAttempted || to.expanded" > 
                <ng-container #fieldComponent></ng-container>
            </app-accordian>
        </div>
    </ion-card>
    `,
    encapsulation: ViewEncapsulation.None,
    standalone: false
}) 
   
  export class CustomAccordianFormlyType extends FieldWrapper {
    fieldGroup:FieldGroupTypeConfig;
    form_name:any;
    constructor(private appservice:AppService) {
      super();
    }
    ngOnInit(){ 
        console.log("123 to=",this.to);
      this.form_name=this.to.form_name;
    }
   
    expandItem(){
        this.to.expanded = !this.to.expanded;
        if(!this.to.expanded){
            let questionaire = this.appservice.appData.cvpc;
            let response:any=[];
            for (const element in questionaire){
                let ques:any = questionaire[element].QUESTIONS;
                let ans= ques.filter(obj=> obj.category==this.to.label);
                if(ans.length >0)
                 response=ans;
            };
            Object.keys(this.formControl.value).forEach(name => {
                let filtered = response.filter(obj1=> obj1.ques ==name);
                if(filtered.length>0)
                  this.formControl.get(name)?.setValue('Not Applicable')
            });
        } 
        console.log("After this.",this.formControl);
    }

    // replace selected relates to icons
    // <ion-card-content>
    //             <app-accordian expandHeight="100px" [expanded]="!to.questionAttempted && to.expanded" *ngIf="!to.questionAttempted || to.expanded" > 
    //                 <ng-container #fieldComponent></ng-container>
    //             </app-accordian>
    //             <ion-row *ngIf="to.questionAttempted && !to.expanded" class="my_inner_selected_cvpc_type">
    //                 {{to.questionAttempted}}
    //             </ion-row>
    //     </ion-card-content>

    // <ion-card-content style="padding:16px;" *ngIf="form_name=='VPC_ADD'">
    //             <app-accordian expandHeight="100px" [expanded]="!to.questionAttempted && to.expanded" *ngIf="!to.questionAttempted || to.expanded" > 
    //                 <ng-container #fieldComponent></ng-container>
    //             </app-accordian>
    //     </ion-card-content>
  }
  